import React from 'react';

import classNames from "classnames";
import {EntityLogo} from "../../../core/components/logos/entity-logo";
import styles from "../styles/language-menu.module.scss";
import {LANGUAGE_MENU} from "../language-menu-module.consts";
import {Link} from "../../../core/components/link/link";

export const LanguageMenuModuleItem = ({controller, language}) => {
  const {state} = controller;
  const {menuModel} = state;
  const {logoSize} = menuModel;

  const logoProps = {
    entity: language,
    width: logoSize,
    height: logoSize
  };

  const containerProps = {
    model: language.linkModel,
    className: classNames(styles.item),
    onClick: () => controller.action(LANGUAGE_MENU.ACTION_TYPES.onItemClick, {language})
  }

  return (
    <Link {...containerProps}>
      <EntityLogo {...logoProps}/>
      <div className={classNames(styles.item_name)}>{language.name}</div>
    </Link>
  )
};
